import keyResources from "./keyResources";
import locationResources from "./locationResources";
import remedies from "./remedies";
import remedy from "./remedy";
import stories from "./stories";
import track from "./track";
import ui from "./ui";

const flows = [
  ...ui,
  ...remedy,
  ...remedies,
  ...keyResources,
  ...track,
  ...stories,
  ...locationResources,
];

export default flows;
